import React from 'react';

import { Box } from '@chakra-ui/react';
import { Add } from '@mesh.ai/rabbit';

import { Publish } from 'assets/assetsV1/iconComponents';

import { isMobileView } from 'constants/helper';

import { BUTTON_VARIANT, Button } from 'uiToolkitV1/Button';

interface BulkPublishAndAddViolationHeaderProps {
  isBulkPublishDisabled?: boolean;
  onBulkPublish: () => void;
  onAddViolation: () => void;
  isBulkPublishVisible?: boolean;
}

function BulkPublishAndAddViolationHeader({
  isBulkPublishDisabled,
  onBulkPublish,
  onAddViolation,
  isBulkPublishVisible = true,
}: BulkPublishAndAddViolationHeaderProps) {
  return (
    <Box
      display="flex"
      justifyContent={isMobileView() && isBulkPublishVisible ? 'space-between' : 'end'}
      alignItems="center"
      gap=" 12px"
      alignSelf="stretch"
    >
      {isBulkPublishVisible && (
        <Button
          variant={BUTTON_VARIANT.outlined}
          StartIcon={Publish}
          disabled={isBulkPublishDisabled}
          onClick={onBulkPublish}
        >
          Bulk publish
        </Button>
      )}
      <Button StartIcon={Add} onClick={onAddViolation}>
        Add new note
      </Button>
    </Box>
  );
}

export { BulkPublishAndAddViolationHeader };
